import React from 'react';
import { Autocomplete } from '../fields';
import { useGetLocationsQuery } from '../../services/dashboardService';
import { useTranslation } from 'react-i18next';
import useConnectionMode from '../../hooks/useConnectionMode';
import { SwitchLayout } from '../custom/SwitchLayout';
import { useEffect } from 'react';
import { Text } from '../custom/text';
import { useNotification } from '../../utils/helpers/notifications';
import { Flex } from '@react-css/flex';
import { Box } from '../custom/box';
import { LabelRequired } from '../custom/LabelRequired';
import { IoIosRefresh } from 'react-icons/io';
import { colors } from '../../style/color';
import { Button } from 'antd';

export const LocationMapping = ({ formik }) => {
    const { isMapClass } = formik.values;
    const [, swName] = useConnectionMode();
    const { t } = useTranslation();

    const { data: locationsList, isFetching: fetchingLocation, isLoading: loadingLocation, refetch: refetchLocations } = useGetLocationsQuery({ class: false }, { skip: !isMapClass ?? true })

    const isLoading = fetchingLocation || loadingLocation

    const { showNotification } = useNotification();

    useEffect(() => {
        if (locationsList && locationsList?.length === 0) {
            showNotification('Location not enabled in accounting software', 'error');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [locationsList])

    return (
        <SwitchLayout
            heading={t('Location', { swName })}
            description={`Adds a Location field on forms so you can assign transactions to different locations like stores, sales regions, and counties.`}
            switchFieldName="isMapClass"
            isSwitchOn={isMapClass}
            isLoading={isLoading}
        >
            <Flex>
                <Box width="49%" pr="1.1rem">
                    <LabelRequired notRequired>
                        {t('Select a Location')}
                    </LabelRequired>
                    <Autocomplete
                        id="locationMapping"
                        name="locations"
                        isLoading={isLoading}
                        options={locationsList}
                        placeholder={t('Select a location')}
                        formik={formik}
                    />
                </Box>
            </Flex>
            <Box mt="1rem" ml=".2rem" width='100%'>
                <Flex justifySpaceBetween>
                    <Flex>
                        <Text fontWeight={"bolder"} mr=".5rem">Required : </Text><Text pr=".2rem">Location mapping</Text>
                    </Flex>
                    <Flex>
                        {!(isLoading) && <IoIosRefresh style={{ color: colors.primary, paddingTop: "5px" }} />}
                        <Button onClick={() => {
                            refetchLocations()
                        }} loading={isLoading} size='small' type='link' style={{ padding: "0 1px", color: colors.primary }}>Refresh Location</Button>
                    </Flex>
                </Flex>
            </Box>
        </SwitchLayout>
    )
}